import styled from 'styled-components'
import { IChildrenNode } from 'types/propTypes'

const SideNav = ({ children }: IChildrenNode) => {
  return <Wrapper data-testid="side-nav">{children}</Wrapper>
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 2px solid ${({ theme }) => theme.colors.tertiary.dark};
  padding-top: 2rem;

  /* Links */
  a {
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 2rem;
    padding: 1rem;

    &.active {
      border-left: 0.5rem solid ${({ theme }) => theme.colors.tertiary.dark};
      background-color: ${({ theme }) => theme.colors.secondary.dark};
    }
  }
`

export { SideNav }
